export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10124.108f33b5.jpg";